<div class="bk-page rep">
  <header class="bk-page__head">
    <div class="bk-page__intro">
      <p class="bk-eyebrow">USSD</p>
      <h1 class="bk-page__title">Reports</h1>
      <p class="bk-page__sub">Sessions, outcomes and networks across your USSD applications.</p>
    </div>
  </header>

  <section class="bk-panel rep__panel" aria-label="USSD reports dashboard">
    @if (!loaded()) {
      <div class="rep__placeholder" aria-hidden="true">
        <div class="rep__skel-row">
          <span class="bk-skel"></span>
          <span class="bk-skel"></span>
          <span class="bk-skel"></span>
        </div>
        <span class="bk-skel rep__skel-chart"></span>
        <span class="bk-skel rep__skel-chart rep__skel-chart--short"></span>
      </div>
    }

    @if (slow()) {
      <div class="rep__slow" role="status">
        <p>The dashboard is taking longer than usual. Check your connection, then reload it.</p>
        <button type="button" class="bk-btn bk-btn--ghost" (click)="reload()">
          <span class="bk-sym" aria-hidden="true">refresh</span>
          Reload dashboard
        </button>
      </div>
    }

    @if (iframeUrl(); as url) {
      @for (n of [attempt()]; track n) {
        <iframe
          [src]="url"
          class="rep__frame"
          [class.is-loaded]="loaded()"
          frameborder="0"
          allowtransparency="true"
          title="USSD reports dashboard"
          (load)="onLoad()"
        ></iframe>
      }
    }
  </section>
</div>
